export const actionStatuses = {
  NOT_COMPLETED: 0,
  EXPIRED: 1,
  COMPLETED: 2
};
